import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, InputAdornment, Typography } from '@mui/material';
import { CustomButton } from '../../../../components/CustomButton';
import { ROUTES } from '../../../../constants/routes';
import { CustomInput } from '../../../../components/CustomInput';
import { ReactComponent as SearchIcon } from '../../../../assets/images/search.svg';
import { useDispatch, useSelector } from 'react-redux';
import { getEventDeclensionForm } from '../../../../utils/getEventDeclension';
import EnhancedTable from '../../../../components/EnhancedTable/EnhancedTable';
import { PACKAGES_HEAD_CELLS } from '../../constants/headCell';
import { PackagesTableBody } from '../PackagesTableBody';
import { NotFoundItems } from '../../../../components/NotFoundItems';
import { getPackages } from '../../../../store/bonuses/actions';
import { BONUSE_PACKAGES_STATUS } from '../../../../constants/variables';
import { FirstTextSelect } from '../../../../components/FirstTextSelcet';
import { CustomSelect } from '../../../../components/CustomSelect';

const styleInput = {
  size: 'small',
  variant: 'outlined'
};

const propsSelect = (name, text, options, value) => ({
  name,
  options,
  value,
  startAdornmentText: <FirstTextSelect text={text} />,
  ...styleInput
});

export const PackagesTab = () => {
  const dispatch = useDispatch();
  const { packages, fetchingPackages } = useSelector((state) => state.bonuses);

  const [filter, setFilter] = useState({
    orderBy: 'id',
    orderType: 'desc',
    status: { value: 'all', label: 'Все' },
    page: 0,
    size: 10
  });


  useEffect(() => {
    dispatch(
      getPackages({
        ...filter,
        page: filter.page + 1,
        status: filter.status.value !== BONUSE_PACKAGES_STATUS[0].value ? filter.status.value : undefined,
        order_type: filter.orderType,
        order_by: filter.orderBy,
        size: filter.size,
        promotion_type: 'bonus'
      })
    );
    // eslint-disable-next-line
  }, [
    filter.status,
    filter.orderType,
    filter.orderBy,
    filter.size,
    filter.page,
  ]);

  const handlerOnChange = (e, field) => setFilter({ ...filter, page: 0, [field]: e });

  return (
    <Box data-testid="PromotionsTab">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb="24px">
        <CustomButton
          component={Link}
          to={{ pathname: ROUTES.BONUSES_CREATE_PACKAGE, state: { from: location?.pathname } }}
          size="small"
          mr="24px"
          variant="contained"
          onClick={() => localStorage.setItem('bonusesTab', 'PACKAGES')}>
          Создать Пакет
        </CustomButton>

        <CustomInput
          value={filter.search}
          onChange={(e) => setFilter({ ...filter, search: e.target.value, page: 0 })}
          size="small"
          {...styleInput}
          placeholder="Поиск"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
        />
      </Box>

      <Box display="grid" gridTemplateColumns="1fr 1fr 1fr 1fr" gap="16px" data-testid="Grid">
        <CustomSelect
          {...propsSelect('status', 'Статус:', BONUSE_PACKAGES_STATUS, filter.status)}
          onChange={(e) => handlerOnChange(e, 'status')}
        />
      </Box>

      {packages?.packages?.length ? (
        <>
          <Typography color="text.secondary" m="24px 0px">
            Найдено {getEventDeclensionForm(packages?.packages?.length, 'partners_events')}
          </Typography>

          <EnhancedTable
            rows={packages?.packages}
            headCells={PACKAGES_HEAD_CELLS}
            filter={filter}
            total={packages?.total_packages || 0}
            fetching={fetchingPackages}
            heightRow={77}
            setFilter={setFilter}>
            <PackagesTableBody
              data={packages?.packages}
              // openModal={() => setIsSuccessModal(true)}
              // setCurID={setCurID}
            />
          </EnhancedTable>
        </>
      ) : (
        <NotFoundItems />
      )}

      {/* <CustomModal
        opened={isSuccessModal}
        modalClose={() => setIsSuccessModal(false)}
        modalSubmit={() => {
          dispatch(archivePromotion(curID));
          dispatchPromotions();
          setIsSuccessModal(false);
        }}
        text="Вы действительно хотите перевести данный пакет в Архив?"
        cancelBtnName="Отмена"
        submitBtnName="Да"
        data-testid="Warning Modal"
      /> */}
    </Box>
  );
};
